import { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Loader2, ArrowLeft, Star } from 'lucide-react';
import { ConsumerLayout } from '@/components/consumer/ConsumerLayout';
import { useOSConsumerDetalhe } from '@/hooks/useConsumerOS';
import { estadoOSConsumer } from '@/lib/consumer-os';
import { formatarMoeda } from '@/lib/currency';
import { AvaliarOSDialog } from '@/components/consumer/AvaliarOSDialog';

export default function ConsumerOSDetalhe() {
  const { t } = useTranslation();
  const { osId } = useParams();
  const { data, isLoading } = useOSConsumerDetalhe(osId);
  const [avaliarOpen, setAvaliarOpen] = useState(false);

  if (isLoading) {
    return <ConsumerLayout><div className="flex justify-center py-16"><Loader2 className="h-6 w-6 animate-spin text-muted-foreground" /></div></ConsumerLayout>;
  }
  if (!data) {
    return (
      <ConsumerLayout>
        <div className="flex flex-col items-center text-center gap-3 py-16">
          <p className="text-sm text-muted-foreground">{t('myOrders.notFound')}</p>
          <Link to="/app/servicos" className="ow-btn ow-btn--outline">{t('myOrders.back')}</Link>
        </div>
      </ConsumerLayout>
    );
  }

  const e = estadoOSConsumer(data.status);
  const fotos = Array.isArray(data.fotos_servico) ? (data.fotos_servico as string[]) : [];
  const podeAvaliar = data.status === 'concluida' && !data.avaliacao;

  return (
    <ConsumerLayout>
      <div className="flex items-center gap-2 mb-4">
        <Link to="/app/servicos" aria-label={t('myOrders.back')}><ArrowLeft className="h-5 w-5" /></Link>
        <span className="font-bold">{data.empresa.nome}</span>
        <span className={`ml-auto text-xs px-2 py-0.5 rounded-full ${e.classe}`}>{t(e.labelKey)}</span>
      </div>

      <div className="flex flex-col gap-4 text-sm">
        {data.servicos.length > 0 && (
          <div><div className="font-medium mb-1">{t('myOrders.services')}</div><div className="text-muted-foreground">{data.servicos.join(', ')}</div></div>
        )}
        {data.valor_total != null && (
          <div><span className="font-medium">{t('myOrders.value')}: </span>{formatarMoeda(data.valor_total)}</div>
        )}
        {data.data_agendada && (
          <div><span className="font-medium">{t('myOrders.scheduled')}: </span>{new Date(data.data_agendada).toLocaleString()}</div>
        )}
        {data.observacoes && (
          <div><div className="font-medium mb-1">{t('myOrders.notes')}</div><div className="text-muted-foreground whitespace-pre-wrap">{data.observacoes}</div></div>
        )}
        {fotos.length > 0 && (
          <div>
            <div className="font-medium mb-1">{t('myOrders.photos')}</div>
            <div className="flex flex-wrap gap-2">{fotos.map((f, i) => <img key={i} src={f} alt="" className="h-20 w-20 rounded-lg object-cover" />)}</div>
          </div>
        )}

        {data.avaliacao ? (
          <div className="ow-card p-3">
            <div className="font-medium mb-1">{t('myOrders.yourRating')}</div>
            <div className="flex gap-0.5">{[1,2,3,4,5].map((n) => <Star key={n} className={`h-4 w-4 ${n <= data.avaliacao!.nota ? 'fill-current text-yellow-500' : 'text-muted-foreground'}`} />)}</div>
            {data.avaliacao.comentario && <p className="text-muted-foreground mt-1">{data.avaliacao.comentario}</p>}
          </div>
        ) : podeAvaliar ? (
          <button type="button" className="ow-btn ow-btn--primary ow-btn--block" onClick={() => setAvaliarOpen(true)}>{t('myOrders.rate')}</button>
        ) : null}
      </div>

      {osId && <AvaliarOSDialog osId={osId} open={avaliarOpen} onOpenChange={setAvaliarOpen} />}
    </ConsumerLayout>
  );
}
